import Immutable from 'immutable';
import { CLEAR_ITINERARY_BOARDING_REPORTS, FLAG_GETTING_ITINERARY_BOARDING_REPORTS, GET_ITINERARY_BOARDING_REPORTS } from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Set(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_GETTING_ITINERARY_BOARDING_REPORTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_ITINERARY_BOARDING_REPORTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ITINERARY_BOARDING_REPORTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
